import React from 'react';
import camelcase from 'camelcase-es5';

import InputLabel from '../InputLabel';
import InputHelper from '../InputHelper';

import TextFieldFormControl from './TextFieldFormControl';
import TextFieldInput from './TextFieldInput';
import TextFieldFooter from './TextFieldFooter';
import TextFieldBase from './TextFieldBase';
import TextFieldPrefix from './TextFieldPrefix';
import useFormControlReducer from '../../hooks/useFormControlReducer';
import TPrefixedTextField from './@types/PrefixedTextField';

const PrefixedTextField = ({
  errorText,
  helperText,
  labelText = '',
  optionalText,
  prefixText,
  charsExceededText,
  charsRemainingText,
  autoComplete,
  step,
  value,
  inputRef,
  isRequired,
  onChange,
  onFocus,
  onBlur,
  onMouseOut,
  onMouseOver,
  onKeyPress,
  type = 'text',
  id = `PrefixedTextField-${camelcase(labelText)}`,
  maxLength,
  name,
  dataTestId,
  inputMode,
  ariaLabel,
  isLive = true,
}: TPrefixedTextField) => {
  const { state, handlers } = useFormControlReducer({
    onChange,
    onFocus,
    onBlur,
    onMouseOut,
    onMouseOver,
    errorText,
    value,
  });

  const { isDirty, isEmpty, isErrored, isFocused, characterCount } = state;
  const { handleChange, handleFocus, handleBlur, handleMouseOver, handleMouseOut } = handlers;

  return (
    <TextFieldBase kind="prefixed">
      {labelText && (
        <InputLabel htmlFor={id} isInputRequired={isRequired} labelText={labelText} optionalText={optionalText} />
      )}
      {helperText && <InputHelper>{helperText}</InputHelper>}
      <TextFieldFormControl isFocused={isFocused} isErrored={isErrored} isDirty={isDirty} isEmpty={isEmpty}>
        <TextFieldPrefix>{prefixText}</TextFieldPrefix>
        <TextFieldInput
          id={id}
          name={name}
          ref={inputRef}
          isRequired={isRequired}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
          onKeyPress={onKeyPress}
          type={type}
          step={step}
          autoComplete={autoComplete}
          inputMode={inputMode}
          data-testid={dataTestId}
          aria-label={ariaLabel}
        />
      </TextFieldFormControl>
      <TextFieldFooter
        maxLength={maxLength}
        characterCount={characterCount}
        isFocused={isFocused}
        isRequired={isRequired}
        errorText={errorText}
        charsExceededText={charsExceededText}
        charsRemainingText={charsRemainingText}
        isLive={isLive}
      />
    </TextFieldBase>
  );
};

export default PrefixedTextField;
